import { XIYOU_INTRODUCED_CHARACTERS } from '@/config/xiyouCharacters'
import {
  buildDongwuModelSpecs,
  buildDongwuTexturesMap
} from '@/config/dongwuManifest'
import {
  buildXinliModelSpecs,
  buildXinliTexturesMap
} from '@/config/xinliSand'
import { resolveStaticUrl } from '@/config/staticAssets'

export { DONGWU_DIR, DONGWU_MODEL_URLS } from '@/config/dongwuManifest'

/**
 * 沙具 FBX 模型（放 static/models）
 * boy.FBX 引用 boy_tex.tga，贴图需同目录放置：static/models/boy_tex.tga
 * chicken.FBX 内嵌路径为 PSD，运行时改用 Chicken.png
 * baiwuchang.FBX 为西游角色合集，每个角色通过 modelKey 单独裁剪网格并指定贴图
 */
export const BOY_MODEL_URL = resolveStaticUrl('/static/models/boy.FBX')
export const CHICKEN_MODEL_URL = resolveStaticUrl('/static/models/chicken.FBX')
export const CHICKEN_TEXTURE_URL = resolveStaticUrl('/static/models/Chicken.png')
export const SHIWU_DIR = resolveStaticUrl('/static/models/shiwu/')
export const CHAOFAN_MODEL_URL = `${SHIWU_DIR}chaofan/model/chaofan.FBX`
export const CHAOFAN_TEXTURE_URL = `${SHIWU_DIR}chaofan/textures/map_chaofan.png`
export const CHAOFAN_THUMB_URL = `${SHIWU_DIR}chaofan/textures/chaofan.png`
export const XIYOU_MODEL_URL = resolveStaticUrl('/static/models/baiwuchang.FBX')
export const XIYOU_TEXTURE_DIR = resolveStaticUrl('/static/models/xiyou/')

/** 旧名保留，避免外部引用报错 */
export const BAIWUCHANG_MODEL_URL = XIYOU_MODEL_URL

/** FBX 贴图路径失效时，手动指定 TGA/PNG */
export const SAND_MODEL_TEXTURES = {
  [CHICKEN_MODEL_URL]: CHICKEN_TEXTURE_URL,
  [CHAOFAN_MODEL_URL]: CHAOFAN_TEXTURE_URL,
  ...buildDongwuTexturesMap(),
  ...buildXinliTexturesMap()
}

/** 每个沙具 3D 变体：key / fbx / 保留网格 / 贴图 */
export const SAND_MODEL_SPECS = Object.create(null)

SAND_MODEL_SPECS[CHAOFAN_MODEL_URL] = {
  key: CHAOFAN_MODEL_URL,
  url: CHAOFAN_MODEL_URL,
  meshKeep: null,
  texture: CHAOFAN_TEXTURE_URL,
  targetHeight: 0.42
}

buildDongwuModelSpecs().forEach((spec) => {
  SAND_MODEL_SPECS[spec.key] = spec
})

buildXinliModelSpecs().forEach((spec) => {
  SAND_MODEL_SPECS[spec.key] = spec
})

XIYOU_INTRODUCED_CHARACTERS.forEach((c) => {
  const key = `xiyou:${c.id}`
  SAND_MODEL_SPECS[key] = {
    key,
    url: XIYOU_MODEL_URL,
    meshKeep: c.meshKeep,
    texture: resolveStaticUrl(`${XIYOU_TEXTURE_DIR}${c.textureFile}`),
    targetHeight: c.targetHeight,
    scaleBoost: c.scaleBoost,
    defaultPropPitch: c.defaultPropPitch != null ? c.defaultPropPitch : null
  }
})

function lookupSandModelSpecByUrl (url) {
  if (!url) return null
  if (SAND_MODEL_SPECS[url]) return SAND_MODEL_SPECS[url]
  const keys = Object.keys(SAND_MODEL_SPECS)
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if (key === url || key.endsWith(url) || url.endsWith(key)) {
      return SAND_MODEL_SPECS[key]
    }
  }
  const slugMatch = url.match(/\/dongwu\/([^/]+)\//)
  if (slugMatch) {
    const slugKey = `dongwu:${slugMatch[1]}`
    if (SAND_MODEL_SPECS[slugKey]) return SAND_MODEL_SPECS[slugKey]
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]
      if (key.indexOf(`/dongwu/${slugMatch[1]}/`) !== -1) {
        return SAND_MODEL_SPECS[key]
      }
    }
  }
  return null
}

export function getSandModelSpec (modelKeyOrUrl) {
  if (!modelKeyOrUrl) return null
  if (typeof modelKeyOrUrl === 'string' && modelKeyOrUrl.indexOf('dongwu:') === 0) {
    if (SAND_MODEL_SPECS[modelKeyOrUrl]) return SAND_MODEL_SPECS[modelKeyOrUrl]
  }
  const direct = lookupSandModelSpecByUrl(modelKeyOrUrl)
  if (direct) return direct
  if (typeof modelKeyOrUrl === 'string' && modelKeyOrUrl.charAt(0) === '/') {
    const url = resolveStaticUrl(modelKeyOrUrl)
    const resolved = lookupSandModelSpecByUrl(url)
    if (resolved) return resolved
    return {
      key: url,
      url,
      meshKeep: null,
      texture: SAND_MODEL_TEXTURES[url] || null
    }
  }
  return null
}

/** 启动时预加载：仅西游合集 FBX（多角色共用一份）；其余沙具按需加载 */
export const SAND_MODEL_PRELOAD = [
  XIYOU_MODEL_URL,
  ...buildDongwuModelSpecs().map((s) => s.key)
]



// WEBPACK FOOTER //
// ./src/config/sandModels.js